import { useGetUserSettingsQuery } from '../store/services/customizeOptionsApi';
import { getCurrencySymbol } from '../constants/currency';

export const useCurrencySymbol = () => {
  const hasAuthToken = Boolean(localStorage.getItem('authToken'));
  const { data } = useGetUserSettingsQuery(undefined, { skip: !hasAuthToken });

  return getCurrencySymbol(data?.currency);
};
